import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import classNames from 'classnames';
import { getGlobalStyleSheets } from '../../global-styles';
import { enumAttributeConverter } from '../enum-types';
import {
   ToastContainerPosition,
   ToastContainerPositionValuesMap,
   ToastPlacement,
   ToastPlacementValuesMap,
} from './types';
import { AtlToastProps } from './props';
import * as TagNames from './toast.tagnames';

@customElement(TagNames.Toast)
export class AtlToast extends LitElement implements AtlToastProps {
   declare show: boolean;
   declare containerClasses?: string;
   declare position?: ToastContainerPosition;
   declare placement?: ToastPlacement;

   static properties = {
      show: { type: Boolean },
      containerClasses: { type: String },
      position: {
         type: String,
         converter: enumAttributeConverter(
            ToastContainerPosition,
            ToastContainerPosition.Fixed
         ),
      },
      placement: {
         type: String,
         converter: enumAttributeConverter(
            ToastPlacement,
            ToastPlacement.TopRight
         ),
      },
   };

   static styles = [...getGlobalStyleSheets()];

   render() {
      if (!this.show) return nothing;

      const placement =
         ToastPlacementValuesMap[this.placement ?? ToastPlacement.TopRight];
      const position =
         ToastContainerPositionValuesMap[
            this.position ?? ToastContainerPosition.Fixed
         ];

      return html`
         <div
            part="container"
            class=${classNames(
               'toast-container',
               this.containerClasses,
               position,
               placement,
               { show: this.show }
            )}
         >
            <slot></slot>
         </div>
      `;
   }
}
